import React, { useState } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'

const FormAddSensors = () => {
    const [temperature, setTemperature] = useState("")
    const [humidity, setHumidity] = useState("")
    const [msg, setMsg] = useState("")

    const navigate = useNavigate();

    axios.defaults.withCredentials = true;

    const saveSensor = async (e) => {
        e.preventDefault();
        try {
            await axios.post('https://ayres-iot-backend.cyclic.app/sensors', {
                temperature: temperature,
                humidity: humidity
            })
            navigate("/sensors")
        } catch (error) {
            if (error.response) {
                setMsg(error.response.data.msg);
            }
        }
    }


    return (
        <div>
            <h1 className='title'>Sensors</h1>
            <h2 className='subtitle'>Add Data</h2>

            <div className="column is-8 is-offset-2">
                <div className="content box">
                    <form onSubmit={saveSensor}>
                        {msg && <div className="notification is-danger is-light">
                            {msg}
                        </div>}
                        <div className="field">
                            <label className="label">Temperature</label>
                            <div className="control">
                                <input type="number" className="input" value={temperature} onChange={(e) => setTemperature(e.target.value)} placeholder='Temperature' />
                            </div>
                        </div>
                        <div className="field">
                            <label className="label">Humidity</label>
                            <div className="control">
                                <input type="number" className="input" value={humidity} onChange={(e) => setHumidity(e.target.value)} placeholder='Humidity' />
                            </div>
                        </div>
                        <div className="field">
                            <div className='control'></div>
                            <button type='submit' className="button is-success">Save</button>
                        </div>
                    </form>
                </div>
            </div >
        </div >

    )
}

export default FormAddSensors